import React, { Component } from "react";
import queryString from "query-string";
import apiCall from "../utils/apiCall"; // Assuming you have a function to make API calls
import HeaderNav from "./common/HeaderNav";
import Footer from "./Footer";
import blogsBanner from "../images/blogs.png";

class BlogDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      blog: null,
      error: null,
    };
  }

  async componentDidMount() {
    try {
      // Get query params
      const queryParams = queryString.parse(window.location.search);
      console.log(queryParams);
      const blogId = queryParams.id; // Assuming ID is passed as ?id=123

      if (!blogId) {
        this.setState({ error: "Blog ID is missing" });
        return;
      }

      // Fetch the blog data
      const { result } = await apiCall("REACT_APP_GET_BLOG", "POST", {
        id: [blogId],
      });
      console.log(result);
      if (result && result.success) {
        this.setState({ blog: result.data });
      } else {
        this.setState({ error: "Blog not found" });
      }
    } catch (error) {
      console.error("Error fetching blog:", error);
      this.setState({ error: "Error fetching blog" });
    }
  }

  render() {
    const { blog, error } = this.state;

    return (
      <>
        <HeaderNav activeTabName="blogs" />
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "300px",
            overflow: "hidden",
            marginTop: "60px",
          }}
        >
          {/* Background Image */}
          <div
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              backgroundImage: `url(${blogsBanner})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          ></div>

          {/* Gradient Overlay */}
          <div
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              background: "#000040",
            }}
          ></div>
          {/* Red circular accent */}
          <div
            style={{
              position: "absolute",
              width: "300px",
              height: "300px",
              backgroundColor: "rgba(255, 0, 0, 0.8)",
              borderRadius: "50%",
              top: "-150px",
              right: "-100px",
              zIndex: 1,
            }}
          ></div>

          {/* Second red circular accent */}
          <div
            style={{
              position: "absolute",
              width: "150px",
              height: "150px",
              backgroundColor: "rgba(255, 0, 0, 0.8)",
              borderRadius: "50%",
              bottom: "-70px",
              left: "50px",
              zIndex: 1,
            }}
          ></div>

          {/* Decorative dots */}
          <div
            style={{
              position: "absolute",
              top: "20px",
              left: "20px",
              display: "flex",
              gap: "5px",
            }}
          >
            <div
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: "rgba(255, 255, 255, 0.7)",
              }}
            ></div>
            <div
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: "rgba(255, 255, 255, 0.7)",
              }}
            ></div>
            <div
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: "rgba(255, 255, 255, 0.7)",
              }}
            ></div>
          </div>

          {/* Decorative triangle */}
          <div
            style={{
              position: "absolute",
              bottom: "15px",
              right: "60px",
              width: 0,
              height: 0,
              borderLeft: "15px solid transparent",
              borderRight: "15px solid transparent",
              borderBottom: "26px solid rgba(255, 255, 255, 0.15)",
              transform: "rotate(45deg)",
            }}
          ></div>

          {/* Content Container */}
          <div
            style={{
              position: "relative",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              padding: "0 20px",
              zIndex: "2",
            }}
          >
            <h1
              style={{
                color: "white",
                fontSize: "42px",
                fontWeight: "800",
                marginBottom: "16px",
                textAlign: "center",
                textShadow: "2px 2px 8px rgba(0, 0, 0, 0.6)",
              }}
            >
              Blogs & Articles
            </h1>

            <p
              style={{
                color: "white",
                fontSize: "18px",
                fontWeight: "400",
                maxWidth: "700px",
                textAlign: "center",
                textShadow: "1px 1px 4px rgba(0, 0, 0, 0.8)",
              }}
            >
              Read our latest blogs and articles to stay updated.
            </p>

            {/* Decorative Line */}
            <div
              style={{
                width: "80px",
                height: "4px",
                background:
                  "linear-gradient(90deg,rgba(255, 255, 255, 0.74), rgb(233, 2, 2))",
                marginTop: "20px",
                borderRadius: "2px",
              }}
            ></div>
          </div>
        </div>
        <div className="container my-5">
          {error ? (
            <div className="alert alert-danger text-center">{error}</div>
          ) : blog ? (
            <div className="blog-details">
              <h1 className="blog-title">{blog[0].title}</h1>
              <p className="text-muted">By {blog[0].author}</p>
              <img
                src={blog[0].imageUrl}
                alt={blog[0].title}
                className="img-fluid rounded shadow my-3"
              />
              <div
                className="blog-content"
                dangerouslySetInnerHTML={{ __html: blog[0].content }}
              ></div>
            </div>
          ) : (
            <div className="text-center">Loading...</div>
          )}
        </div>
        <Footer />
      </>
    );
  }
}

export default BlogDetails;
